// src/select/select-context.ts
import { createContext } from "react";
var SelectItemCheckedContext = createContext(false);
var SelectContext = createContext(void 0);
export { SelectItemCheckedContext, SelectContext };